import { QuinnChatSummary } from "../../types";
import { formatChatTimestamp } from "../../utils/chatHistory.ts";

type ChatRowProps = {
    chat: QuinnChatSummary;
    isActive: boolean;
    onSelect: () => void;
};

export function ChatRow({ chat, isActive, onSelect }: ChatRowProps) {
    return (
        <button
            type="button"
            onClick={onSelect}
            aria-current={isActive ? "true" : undefined}
            className={`mx-1 flex w-[calc(100%-0.5rem)] items-baseline gap-2 rounded-lg px-2 py-1.5 text-left transition-colors ${
                isActive ? "bg-gray-100" : "hover:bg-gray-50"
            }`}
        >
            <span className="min-w-0 flex-1">
                <span className={`block truncate text-xs ${isActive ? "font-medium text-gray-900" : "text-gray-800"}`}>
                    {chat.title}
                </span>
                <span className="block truncate text-[10px] text-gray-400">{chat.businessLabel}</span>
            </span>
            <span className="shrink-0 text-[10px] tabular-nums text-gray-400">{formatChatTimestamp(chat.updatedAt)}</span>
        </button>
    );
}
